<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>help</v-icon>
          Creating Medical Certificates
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" vertical non-linear>
        <v-stepper-step editable step="1">
          <span class="blue--text" @click="openPage('help-signin')">Sign in</span> and click on "Create" item under the "Medical Certificates" menu.
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_1.png">
          </v-card>
          <v-btn color="primary" @click="step = 2">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="2">
          Inform the Patient ID
          <small>Either fill in the Patient ID in the text box, or click on the QRCode button.</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_2.png">
          </v-card>
          <v-btn color="primary" @click="step = 3">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="3">
          Read the QRCode
          <small>If you have clicked on the QRCode button, point the User ID QRCode to your camera.</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_3.png">
          </v-card>
          <v-btn color="primary" @click="step = 4">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="4">
          Fill out the Certificate info
          <small>
            Only Physicians can create Medical Certificates.
            <br>
            Patient details cannot be updated in here. Only administrators can do that in the "Patients/Find" menu.
            <br>
            The Physician needs to be assigned to at least one Health Facility.
            <br>
            "Diagnosis", "Recommendation" and "Days of rest" are mandatory fields.
          </small>
        </v-stepper-step>

        <v-stepper-content step="4">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_4.png">
          </v-card>
          <v-btn color="primary" @click="step = 5">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="5">
          Confirm the transaction
          <small>
            If you haven't taken note of the Certificate ID, please do so.
            <br>
            Click on "Copy" button and paste it somewhere safe.
            <br>
            Click on "Confirm" to send the registration transaction to Althash blockchain.
          </small>
        </v-stepper-step>

        <v-stepper-content step="5">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_5.png">
          </v-card>
          <v-btn color="primary" @click="step = 6">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="6">
          Wait for the transaction to confirm
          <small>
            The Althash blockchain takes just a few minutes to confirm a transaction.
            <br>
            Wait for it to confirm.
          </small>
        </v-stepper-step>

        <v-stepper-content step="6">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_6.png">
          </v-card>
          <v-btn color="primary" @click="step = 7">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="7">
          Certificate created!
          <small>
            The transaction was confirmed. 
            <br>
            You can click on "Open certificate" button to open a window with Certificate Info.
            <br>
            You can also click on "Create another certificate" to go back to the creation form.
          </small>
        </v-stepper-step>

        <v-stepper-content step="7">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_7.png">
          </v-card>
          <v-btn color="primary" @click="step = 8">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="8">
          Certificate Info
          <small>
            You can print this window and hand it to the Patient.
            <br>
            With the QRCode any authorized users can verify the certificate validity.
          </small>
        </v-stepper-step>

        <v-stepper-content step="8">
          <v-card class="mb-5">
            <img src="~assets/images/help_certstandardcreate_8.png">
          </v-card>
          <v-btn color="primary" @click="step = 1">Back to start</v-btn>
          <v-btn flat @click="openPage('help')">Back to help</v-btn>
        </v-stepper-content>

      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: ['localUserType'],
  data () {
    return {
      localUserType: this.localUserType,
      step: 1
    }
  },
  methods: {
    openPage(name) {
      this.$emit("openPage", name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Help-Certstandardcreate.vue